import { MARGIN_POLLING_INTERVAL } from "~/v2/constants";
import { queryKeys } from "../queryKeys";
import { getMargin, type Margin } from "../rest/account";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetMargin = ({
  accountID,
  paper,
  options,
}: {
  accountID?: string;
  paper?: boolean;
  options?: QueryOptions<Margin | null>;
}) => {
  const response = useRequest(
    queryKeys.balances.margin(accountID || "", paper),
    () => getMargin(accountID || "", paper),
    {
      refetchInterval: MARGIN_POLLING_INTERVAL,
      ...options,
    },
  );

  return { margin: response.data, ...response };
};

export const useGetMargins = ({
  accountIDs,
  paper,
  options,
}: {
  accountIDs?: string[];
  paper?: boolean;
  options?: QueryOptions<Margin[]>;
}) => {
  const { data: margin } = useRequest(
    queryKeys.balances.marginMulti(accountIDs || [], paper),
    async () => {
      const ids = accountIDs || [];
      const margins = await Promise.all(ids.map((id) => getMargin(id, paper)));
      return margins.filter((m): m is Margin => !!m);
    },
    {
      ...options,
    },
  );

  return { margin };
};

export default useGetMargin;
